import {NotationLayoutEnum} from "../../models/view/lessonPage/NotationLayoutEnum";
import deviceInfo from "../deviceInfo/deviceInfo";
import {lessonPlayerStore} from "../../redux/lesson/LessonPlayerStore";
import {isInLandscapeOrientation} from "../../util/screenUtil";
import {SegmentModeEnum} from "../../models/view/lessonPage/SegmentModeEnum";
import Lesson from "../../models/view/lessonPage/Lesson";
import { NavigateFunction } from "react-router-dom";

export function getNotationLayoutToApplyFromSelectedNotationLayout(): NotationLayoutEnum {
  const isMobile = deviceInfo.getIsMobile();
  const selectedNotationLayout = lessonPlayerStore.getSelectedNotationLayout();

  if (selectedNotationLayout !== NotationLayoutEnum.auto) {
    return selectedNotationLayout;
  }

  if (!isMobile) {
    return NotationLayoutEnum.vertical;
  }

  const isLandscapeOrientation = isInLandscapeOrientation();

  return isLandscapeOrientation ? NotationLayoutEnum.horizontal : NotationLayoutEnum.vertical;
}

export function goToPreviousSegment(navigate: NavigateFunction) {
  const lesson = lessonPlayerStore.getLesson();
  const segment = lessonPlayerStore.getSegment();
  const currentSegment = lesson && segment ? segment : undefined;
  const currentSegmentId = currentSegment?.id || "";
  const currentSegmentMode = currentSegment?.mode || undefined;
  const previousSegment = getPreviousSegment(currentSegmentId, currentSegmentMode, lesson);
  if(previousSegment) {
    navigate(previousSegment.url, {replace: true});
  }
}

function getPreviousSegment(currentSegmentId: string, currentSegmentMode?: SegmentModeEnum, lesson?: Lesson){
  if (!lesson) { return; }
  const indexOfCurrentSegmentId = lesson.segments.findIndex(s => s.id === currentSegmentId && (currentSegmentMode === undefined || s.mode === currentSegmentMode));
  const indexOfPreviousSegment = indexOfCurrentSegmentId - 1 < 0 ? 0 : indexOfCurrentSegmentId - 1;
  return lesson.segments[indexOfPreviousSegment];
}

export function goToNextSegment(navigate: NavigateFunction) {
  const lesson = lessonPlayerStore.getLesson();
  const segment = lessonPlayerStore.getSegment();
  const currentSegment = lesson && segment ? segment : undefined;
  const currentSegmentId = currentSegment?.id || "";
  const currentSegmentMode = currentSegment?.mode || undefined;
  const nextSegment = getNextSegment(currentSegmentId, currentSegmentMode, lesson);
  if(nextSegment) {
    navigate(nextSegment.url, {replace: true});
  }
}

function getNextSegment(currentSegmentId: string, currentSegmentMode?: SegmentModeEnum, lesson?: Lesson){
  if (!lesson) { return; }
  const indexOfCurrentSegmentId = lesson.segments.findIndex(s => s.id === currentSegmentId && (currentSegmentMode === undefined || s.mode === currentSegmentMode));
  if (indexOfCurrentSegmentId < 0) {
    return lesson.segments[0];
  }
  const indexOfNextSegment = indexOfCurrentSegmentId + 1 >= lesson.segments.length ? indexOfCurrentSegmentId : indexOfCurrentSegmentId + 1;
  return lesson.segments[indexOfNextSegment];
}

let nextSegmentDropdownClosePromiseResolve: ((value?: unknown) => void) | undefined;
let timeoutId = 0;
export function controlBarClicked() {
  const isPlaying = lessonPlayerStore.getIsPlaying();
  if (!isPlaying) {
    return;
  }
  lessonPlayerStore.setIsControlBarIsPartiallyHidden(false);
  //when the control bar is clicked while playback is occurring, we want to show the hidden controls for 2 seconds, and keep them shown if the user is interacting with them.
  //after they are done interacting, we want to wait 2 seconds and then hide them
  function recursiveSetTimeout(){
    window.clearTimeout(timeoutId); //if the user clicks the bar more than once, we don't want old timers firing.
    timeoutId = window.setTimeout(()=> {
      const isPlaying = lessonPlayerStore.getIsPlaying();
      const isSegmentDropdownSelectorOpen = lessonPlayerStore.getIsSegmentSelectorDropdownOpen();
      if (isSegmentDropdownSelectorOpen) { //if the selector is open, cancel the timeout and wait for it to close.
        window.clearTimeout(timeoutId);
        const nextSegmentDropdownClosePromise = new Promise((resolve)=> nextSegmentDropdownClosePromiseResolve = resolve);
        nextSegmentDropdownClosePromise.then(()=> recursiveSetTimeout());
      } else {
        lessonPlayerStore.setIsControlBarIsPartiallyHidden(isPlaying);
      }
    }, 2000);
  }
  recursiveSetTimeout();
}